<shared-modal [mobile]="sharedService.screenSize !== 'l'">
  <!-- header -->
  <h2 slot="header">Importar lista de contatos</h2>

  <!-- body -->
  <div class="flex flex-col gap-3">
    <ul class="pl-4">
      <li>Formate sua planilha conforme o exemplo abaixo</li>
      <li>
        <strong>Números de telefone</strong> devem estar na primeira coluna
      </li>
      <li>
        Colunas adicionais podem ser usadas como <strong>variáveis</strong> na
        mensagem (adicione um nome no cabeçalho de cada coluna)
      </li>
      <li>
        Salve no formato <strong>.csv separado por vírgulas</strong> (Excel)
      </li>
      <li>
        Inclua <strong>200 contatos ou menos</strong> por lista para evitar
        banimentos
      </li>
    </ul>

    <div class="overflow-x-auto">
      <table>
        <thead>
          <tr>
            <th>Numero</th>
            <th>Nome</th>
            <th>Matricula</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>31987654321</td>
            <td>João Silva</td>
            <td>12345</td>
          </tr>
          <tr>
            <td>31912345678</td>
            <td>Maria Santos</td>
            <td>67890</td>
          </tr>
          <tr>
            <td>31998765432</td>
            <td>Pedro Oliveira</td>
            <td>24680</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <b style="color: rgb(var(--functional-red))">{{
    importErrorMessage | async
  }}</b>

  <!-- footer -->
  <button
    slot="footer"
    class="secondary"
    (click)="sharedService.closeModal(route)"
  >
    Cancelar
  </button>
  <button slot="footer" (click)="csvImportInput.click()" [disabled]="isLoading">
    {{ isLoading ? 'Carregando...' : 'Escolher lista' }}
  </button>
</shared-modal>

<!-- csv import input -->
<input
  type="file"
  accept=".csv"
  placeholder="Search"
  (change)="handleCsvImport($event)"
  hidden
  #csvImportInput
/>
